"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _NewApiKeyModal = _interopRequireDefault(require("./NewApiKeyModal"));
var _apiKeyActions = require("../../../redux/actions/apiKeyActions");
var _snackbarActions = require("../../../redux/actions/snackbarActions");
var _modalDecorator = _interopRequireDefault(require("../../../hocs/modalDecorator"));
var _modalActions = require("../../../redux/actions/modalActions");
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    numberOfApiKeys: state.apiKey.apiKeys.length,
    userId: state.user.userInfo.UserId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addApiKey: function addApiKey(apiKey) {
      dispatch((0, _apiKeyActions.addApiKey)(apiKey));
      dispatch((0, _sidePaneActions.closeApiKeysSidePane)());
    },
    removeApiKey: function removeApiKey(apiKey) {
      return dispatch((0, _apiKeyActions.removeApiKey)(apiKey));
    },
    showSnack: function showSnack(payload) {
      return dispatch((0, _snackbarActions.showSnack)(payload));
    }
  };
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_NewApiKeyModal["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.NEW_API_KEY
})(container);